import { useEffect, useRef } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/hooks/useAuth';

/**
 * On login, calls an edge function that checks if the user has draft
 * activities and inserts a "Continue your listing" notification (once/day).
 */
export const useDraftReminder = () => {
  const { user } = useAuth();
  const checkedRef = useRef(false);

  useEffect(() => {
    if (!user || checkedRef.current) return;
    checkedRef.current = true;

    supabase.functions.invoke('check-draft-reminder').catch((err) => {
      console.error('Draft reminder check failed:', err);
    });
  }, [user]);
};
